import { observable, makeObservable, runInAction } from "mobx";

export class ProjectItemType {
  static Folder = 0;
  static Project = 1;
}

export default class ProjectItem {
  id = "";
  name = "";
  type = ProjectItemType.Folder;
  items = []; //ProjectItem[]
  data = null; //any

  constructor() {
    makeObservable(this, {
      id: observable,
      name: observable,
      type: observable,
      items: observable,
      data: observable,
    });
  }

  static fromJS(object) {
    return runInAction(() => {
      const item = new ProjectItem();
      if (object) {
        item.id = object.id || "";
        item.name = object.name || "";
        item.type = object.type;
        item.data = object.data || null;
        
        if (object.items && Array.isArray(object.items)) {
          item.items = object.items.map((subItem) => ProjectItem.fromJS(subItem));
        }
      }
      return item;
    });
  }

  toJS() {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      data: this.data,
      items: this.items.map(item => item.toJS())
    };
  }
}